import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { login } from '../../redux/actions/authenticationActions';

import PropTypes from 'prop-types';

import { Link, Navigate } from "react-router-dom";





class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            errors: {},
            error: this.props.error,
            capswarning: false
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(e) {
        
        this.setState({
            [e.target.name]: e.target.value
        })

    }

    componentDidUpdate(prevpros) {
        if ((prevpros.error)!==(this.props.error)) 
            console.log(this.props.error)
    }

    handleSubmit(e) {
        
        e.preventDefault();

        const {email, password} = this.state
        const user = {
            User: email,
            Password: password,
        }
        const { dispatch } = this.props
        dispatch(login(user));

    }


    onBlur = () => {
        this.setState({ capswarning: false });

    }


    onKeyDown = keyEvent => {
        if (keyEvent.getModifierState("CapsLock")) {
            this.setState({ capswarning: true });
        } else {
            this.setState({ capswarning: false });
        }
    };

    render() {
        //const { errors } = this.state;
        //const { getFieldDecorator } = this.props.form;
        if (this.props.authorized === true) return (<Navigate to='/' replace />)
        return (
            <div className='container' style={{ height:'80vh' }}>
                <div className='container' style={{ bottom: '0px', right:'0px', width: '400px', height: '320px' }}>
                    <h2 style={{ marginBottom: '40px' }}>Veuillez vous Identifier</h2>
                    <form onSubmit={this.handleSubmit} className='login-form'>
                        <div className="form-group row">
                            <label htmlFor="email" className="col-sm-4 col-form-label">Email</label>
                            <div className="col-sm-8">
                                <input name='email' type="email" className="form-control" id="email" placeholder="Entrez votre Identifiant!" onChange={this.handleInputChange} />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label htmlFor="password" className="col-sm-4 col-form-label">Mot de passe</label>
                            <div className="col-sm-8">
                                <input name='password' type="password" className="form-control" id="password" placeholder="Entrez votre mot de passe!" onChange={this.handleInputChange} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-sm-6">
                                <button type="button" className="btn btn-primary" onClick={this.handleSubmit}>Connexion</button>
                            </div>
                            <div className="col-sm-6">
                                <Link to="/PasswordLost" >Mot de passe oublié</Link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}



const mapStateToProps = state => {
    return {
        error: state.authentication.error,
        authorized: state.authentication.authorized,
    }
}
Login.propTypes = {
    error: PropTypes.any,
    dispatch: PropTypes.func,
    form: PropTypes.any,
    authorized: PropTypes.bool,
};

export default connect(mapStateToProps)(Login)